const dynamicSort = (property: string, order: string = 'ascend') => {
  const sortOrder = order === 'ascend' ? 1 : -1
  return (a: any, b: any) => {
    const result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0
    return result * sortOrder
  }
}

export default dynamicSort
